var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.76013C7.51952 1.88103 9.24451 1.41943 11 1.42213C16.523 1.42213 21 5.89913 21 11.4221C21 16.9451 16.523 21.4221 11 21.4221C5.477 21.4221 1 16.9451 1 11.4221C1 9.60113 1.487 7.89213 2.338 6.42213",
    stroke: "white",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.828 18.4931C13.457 19.4221 13.016 20.1581 12.531 20.6611C12.045 21.1631 11.525 21.4221 11 21.4221C10.475 21.4221 9.955 21.1631 9.47 20.6611C8.984 20.1581 8.543 19.4211 8.172 18.4931C7.8 17.5641 7.505 16.4631 7.304 15.2491C7.09897 13.9838 6.9973 12.7039 7 11.4221C7 10.1091 7.103 8.80812 7.304 7.59512C7.505 6.38212 7.8 5.28012 8.172 4.35112C8.543 3.42212 8.984 2.68612 9.469 2.18312C9.955 1.68212 10.475 1.42212 11 1.42212C11.525 1.42212 12.045 1.68112 12.53 2.18312C13.016 2.68612 13.457 3.42312 13.828 4.35112C14.2 5.28012 14.495 6.38112 14.695 7.59512C14.897 8.80812 15 10.1091 15 11.4221C15 12.7351 14.896 14.0361 14.695 15.2491M1 11.4221H9M21 11.4221H13",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangeIcon);
export default __webpack_public_path__ + "static/media/lange_icon.50a69cc352e696eb3ea229dc8ce857ff.svg";
export { ForwardRef as ReactComponent };